// Junta classes condicionais e resolve conflito entre classes do mesmo grupo (a última vence), como quem lê
// o JSX espera: cn("h-controle", "h-12") -> "h-12". Sem isso, vencia a ordem do CSS gerado (QA fidelidade P-8).
//
// O tailwind-merge precisa conhecer a escala própria do tokens.css (@theme). Sem a configuração ele
// classificaria `text-titulo` como COR e o removeria ao lado de `text-tinta`, ou não saberia que `h-toque` e
// `h-10` disputam a mesma altura. Ao criar token novo no @theme, acrescente o nome aqui (o teste confere).
import { extendTailwindMerge } from "tailwind-merge";

/** Nomes do @theme de tokens.css, por grupo. Exportado para o teste de sincronia com o CSS. */
export const TEMA_TW = {
  text: [
    "cronometro",
    "display-xl",
    "display",
    "numero",
    "h1",
    "h2",
    "titulo",
    "corpo",
    "apoio",
    "rotulo",
    "botao",
    "aba",
  ],
  spacing: ["margem", "controle", "toque", "aba", "topo", "sidebar"],
  container: ["app", "leitura", "painel"],
  radius: ["celula", "controle", "card", "placa", "folha"],
  shadow: ["anel", "folha", "toast", "modal"],
  ease: ["gs", "gs-saida"],
  animate: [
    "brilho",
    "pop",
    "subir",
    "folha-entra",
    "fade-entra",
    "tela-entra",
    "toast-entra",
    "pulso-fim",
    "giro",
  ],
} as const;

const mesclar = extendTailwindMerge({
  extend: {
    theme: {
      text: [...TEMA_TW.text],
      spacing: [...TEMA_TW.spacing],
      container: [...TEMA_TW.container],
      radius: [...TEMA_TW.radius],
      shadow: [...TEMA_TW.shadow],
      ease: [...TEMA_TW.ease],
      animate: [...TEMA_TW.animate],
    },
  },
});

/** Junta classes condicionais: cn("a", cond && "b", undefined) -> "a b", resolvendo conflitos Tailwind. */
export function cn(...classes: Array<string | false | null | undefined | 0>): string {
  return mesclar(classes.filter(Boolean).join(" "));
}
